import axiosApiInstance from '../../interceptors/axiosApiInstance';
import { BASE_URL } from '../config';

const LibraryService = {
    getAllLibrary: async function () {
        try {
            const response = await axiosApiInstance.get(await BASE_URL + '/library/actions');
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    getLibraryImagePath: async function (library_name) {
        try {
            const response = await axiosApiInstance.get(await BASE_URL + `/library/image/path`, { params: { library_name } });
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    getLibrary: async function (filter) {
        try {
            filter = filter.queryParam;
            let filters = "?";
            if (filter.is !== undefined)
                filters += `is=${filter.is}`;

            if (filter.i !== undefined && (filter.is === undefined || !filter.is)) {
                filters += `&i=${filter.i}`;
            }

            if (filter.m !== undefined && filter.m) {
                filters += `&m=${filter.m}`;
            }

            if (filter.environment_target !== undefined) {
                filters += `&environment_target=${filter.environment_target}`;
            }

            const response = await axiosApiInstance.get(await BASE_URL + `/library${filters}`);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    getLibraryVersion: async function (library_label, environment_target) {
        try {
            const response = await axiosApiInstance.get(await BASE_URL + `/library/version?library_label=${library_label}&environment_target=${environment_target ? environment_target : 'local'}`);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    getLibraryVersionAction: async function (id, environment_target) {
        try {
            const response = await axiosApiInstance.get(await BASE_URL + `/library/${id}/version-actions?environment_target=${environment_target ? environment_target : 'local'}`);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    getLibraryActions: async function (library_id) {
        try {
            const response = await axiosApiInstance.get(await BASE_URL + `/library/${library_id}/actions`);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    upgradeLibrary: async function (data) {
        try {
            const response = await axiosApiInstance.put(await BASE_URL + `/library/version/change`, data);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    addLibrary: async function (data) {
        try {
            const response = await axiosApiInstance.post(await BASE_URL + `/library/custom`, data, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    publishCustomAction: async function (data) {
        try {
            const response = await axiosApiInstance.post(await BASE_URL + `/library/custom/action-publish`, data, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    publishCustomLibrary: async function (data) {
        try {
            const response = await axiosApiInstance.post(await BASE_URL + `/library/custom/publish`, data);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    downloadCustomLibrary: async function (id, data) {
        try {
            const response = await axiosApiInstance.post(await BASE_URL + `/library/${id}/download`, data);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    downloadCustomLibraryByLabel: async function (data) {
        try {
            const response = await axiosApiInstance.post(await BASE_URL + `/library/download`, data);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    checkingLibrary: async function (environment_target, id) {
        try {
            const response = await axiosApiInstance.get(await BASE_URL + `/library/exists?environment_target=${environment_target}&id=${id}`);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    listLibraryAction: async function (id, library_version_id) {
        try {
            const response = await axiosApiInstance.get(await BASE_URL +
                `/library/custom/action?library_id=${id}&version_id=${library_version_id}`);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    getOwnVendor: async function (environment_target, vendor) {
        try {
            const response = await axiosApiInstance.get(await BASE_URL + `/library/custom?environment_target=${environment_target}&vendor=${vendor}`,);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    getActionDetail: async function (action_id) {
        try {
            const response = await axiosApiInstance.get(await BASE_URL + `/library/custom/action/detail?action_id=${action_id}`,);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    getLibraryVersions: async function (library_label, et) {
        try {
            let environmentTarget = "";
            if (et === "global") {
                environmentTarget = `&environment_target=${et}`
            }
            const response = await axiosApiInstance.get(await BASE_URL + `/library/versions?library_label=${library_label}${environmentTarget}`);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    getGlobalLibraryVersions: async function (library_label) {
        try {
            const response = await axiosApiInstance.get(await BASE_URL + `/library/versions?library_label=${library_label}&environment_target=global`);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    checkNonExistingLibraries: async function (data) {
        try {
            const response = await axiosApiInstance.post(await BASE_URL + `/library/check`, data);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    }
};
export default LibraryService;
